module.exports = __webpack_public_path__ + "img/logo.02598794.jpg";